import type { ConsentDocumentVersion } from '@/api/consentDocuments/consentDocumentsApi.types';

export function resolveActiveLanguageTitle(
  version: ConsentDocumentVersion,
  language: string
): string {
  if (language.startsWith('pl') === true && version.titlePl.trim().length > 0) {
    return version.titlePl;
  }
  return version.titleEn;
}
